import { render, staticRenderFns } from "./CreateUpdateIngredient.vue?vue&type=template&id=5671a018&scoped=true&"
import script from "./CreateUpdateIngredient.vue?vue&type=script&lang=js&"
export * from "./CreateUpdateIngredient.vue?vue&type=script&lang=js&"
import style0 from "./CreateUpdateIngredient.vue?vue&type=style&index=0&id=5671a018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5671a018",
  null
  
)

export default component.exports